import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex align-items-stretch flex-shrink-0" }
const _hoisted_2 = { class: "topbar d-flex align-items-stretch flex-shrink-0" }
const _hoisted_3 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_4 = {
  class: "\n            btn btn-icon btn-active-light-primary\n            w-30px\n            h-30px\n            w-md-40px\n            h-md-40px\n          ",
  id: "kt_activities_toggle"
}
const _hoisted_5 = { class: "svg-icon svg-icon-1" }
const _hoisted_6 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_7 = {
  class: "\n            btn btn-icon btn-active-light-primary\n            w-30px\n            h-30px\n            w-md-40px\n            h-md-40px\n          ",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_8 = { class: "svg-icon svg-icon-1" }
const _hoisted_9 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_10 = {
  class: "\n            btn btn-icon btn-active-light-primary\n            position-relative\n            w-30px\n            h-30px\n            w-md-40px\n            h-md-40px\n          ",
  id: "kt_drawer_chat_toggle"
}
const _hoisted_11 = { class: "svg-icon svg-icon-1" }
const _hoisted_12 = /*#__PURE__*/_createVNode("span", { class: "\n              bullet bullet-dot\n              bg-success\n              h-6px\n              w-6px\n              position-absolute\n              translate-middle\n              top-0\n              start-50\n              animation-blink\n            " }, null, -1)
const _hoisted_13 = { class: "d-flex align-items-center ms-1 ms-lg-3" }
const _hoisted_14 = {
  class: "\n            btn btn-icon btn-active-light-primary\n            position-relative\n            w-30px\n            h-30px\n            w-md-40px\n            h-md-40px\n          ",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}
const _hoisted_15 = { class: "svg-icon svg-icon-1" }
const _hoisted_16 = {
  class: "d-flex align-items-center me-n3 ms-1 ms-lg-3",
  id: "kt_header_user_menu_toggle"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("div", {
  class: "\n            btn btn-icon btn-active-light-primary\n            w-30px\n            h-30px\n            w-md-40px\n            h-md-40px\n          ",
  "data-kt-menu-trigger": "click",
  "data-kt-menu-attach": "parent",
  "data-kt-menu-placement": "bottom-end",
  "data-kt-menu-flip": "bottom"
}, [
  /*#__PURE__*/_createVNode("img", {
    src: "media/avatars/150-25.jpg",
    alt: "metronic",
    class: "h-25px w-25px rounded"
  })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_KTQuickLinksMenu = _resolveComponent("KTQuickLinksMenu")!
  const _component_KTNotificationsMenu = _resolveComponent("KTNotificationsMenu")!
  const _component_KTUserMenu = _resolveComponent("KTUserMenu")!

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("span", _hoisted_5, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen032.svg" })
          ])
        ])
      ]),
      _createVNode("div", _hoisted_6, [
        _createVNode("div", _hoisted_7, [
          _createVNode("span", _hoisted_8, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen025.svg" })
          ])
        ]),
        _createVNode(_component_KTQuickLinksMenu)
      ]),
      _createVNode("div", _hoisted_9, [
        _createVNode("div", _hoisted_10, [
          _createVNode("span", _hoisted_11, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/communication/com012.svg" })
          ]),
          _hoisted_12
        ])
      ]),
      _createVNode("div", _hoisted_13, [
        _createVNode("div", _hoisted_14, [
          _createVNode("span", _hoisted_15, [
            _createVNode(_component_inline_svg, { src: "media/icons/duotune/general/gen022.svg" })
          ])
        ]),
        _createVNode(_component_KTNotificationsMenu)
      ]),
      _createVNode("div", _hoisted_16, [
        _hoisted_17,
        _createVNode(_component_KTUserMenu)
      ])
    ])
  ]))
}